import { siteConfig } from "~/config/site"

export const linksConfig = {
  builtWith: "https://dirstarter.com?atp=wally",
  selfHost: "",
  author: "wallycchen",
  twitter: "https://x.com/iotsecpulse",
  analytics: "",
  kofi: "https://ko-fi.com/wallycchen",
  feeds: [
  ],
  family: [
  ],
  toolsUsed: [
  ],
  featured: [
  ],
}
